module.exports = __webpack_public_path__ + "a8a10a3e/img/scraper-icon.df6ccde5.svg";